import {registerPlugin} from "surveylabJsAssets/chart/charts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";
import {Options} from "highcharts";

export class Diary extends AbstractChart {
    protected static LIGHT_GRAY = '#f0f0f0';
    protected static DARK_GRAY = '#d0d0d0';
    protected static ROW_BASE_HEIGHT = 15;
    protected static LEGEND_HEIGHT = 30;
    protected static DIARY_LENGTH = 20;

    protected allChartOptions(): Options {
        const options: Options = {
            chart: {
                type: 'line',
                inverted: true,
                spacingLeft: 0,
                spacingRight: 0,
            },
            xAxis: {
                min: -0.5,
                labels: {
                    enabled: false,
                },
                lineWidth: 0,
            },
            yAxis: {
                tickPositions: [1, 2, 3, 4, 5],
                labels: {
                    enabled: false,
                },
            },
            legend: {
                enabled: false,
            },
        }

        return super.mergeOptions(super.allChartOptions(), options);
    }

    protected preCreationOptions(): Options {
        const options = super.preCreationOptions();
        const isLegendEnabled = options.legend?.enabled ?? false;
        const plotBands = [...Array(Diary.DIARY_LENGTH).keys()].map((_, i) => ({
            from: i - 0.5,
            to: i + 0.5,
            color: i % 2 === 0 ? Diary.LIGHT_GRAY : Diary.DARK_GRAY,
        }));
        const rowBaseHeight = Diary.ROW_BASE_HEIGHT;
        const legendHeight = isLegendEnabled ? Diary.LEGEND_HEIGHT : 0;
        return super.mergeOptions(options, {
            chart: {
                height: Diary.DIARY_LENGTH * rowBaseHeight + (isLegendEnabled ? legendHeight : 0),
            },
            xAxis: {
                max: Diary.DIARY_LENGTH - 0.5,
                plotBands,
            },
            legend: {
                itemDistance: 15,
            }
        });
    }
}

// noinspection JSUnusedGlobalSymbols
export default function () {
    registerPlugin(Diary)
}